import { IDropDownDisciplinaUseCase } from "../../../presentation/useCases/read/drop_down_disciplina_use_case";
import { GetDropDownDisciplinaRequestModel, GetDropDownDisciplinaResponseModel } from "../../models/disciplina_models";
import { IProjetosRepository } from "../../repositories/projetos_repository";

/**
 * DropDownDisciplinaUseCase
 */

export class DropDownDisciplinaUseCase implements IDropDownDisciplinaUseCase {
  constructor(private readonly repository: IProjetosRepository) {}

  async dropDownDisciplina(request: GetDropDownDisciplinaRequestModel): Promise<GetDropDownDisciplinaResponseModel[]> {
    return await this.repository.getDropDownDisciplina(request);
  }
}
